import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { CalculationService, DataService, DateService, FormatService, HelperService, HTTPService, SocketService, ValidationService } from 'app/services';
import { config, messages, paymentTypes } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { PayrixPaymentFieldComponent } from './payrix-payment-field/payrix-payment-field.component';
import { paymentObject, SocketPayment } from 'app/services/sharedInterfaces';
import { SwipeCardConfirmationComponent } from './swipe-card-confirmation/swipe-card-confirmation.component';
import { currency } from 'app/constants/currency.constants';
import { takeUntil } from 'rxjs/operators';

import { environment } from 'environments/environment';

import { findIndex, orderBy, sum, find } from 'lodash';
import { Subject, Subscription } from 'rxjs';
import { GlobalPaymentFieldComponent } from './global-payment-field/global-payment-field.component';

@Component({
  selector: 'app-payment-add',
  templateUrl: './payment-add.component.html',
  styleUrls: ['./payment-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class PaymentAddComponent implements OnInit, OnDestroy {
  isArchived: boolean = false;
  isNotVehicleInfo: boolean = false;
  isInvoiceLocked: boolean = false;
  estimateSearchResults: any[] = [];
  customerSearchResults: any[] = [];
  paymentMethods: any[] = [];
  payrixPaymentMethod: any[] = [];
  cashPaymentMethods: any[] = [];
  cardPaymentMethods: any[] = [];
  otherPaymentMethods: any[] = [];
  globalPaymentMehod: any[] = [];
  defaultTitle: string = config.defaultTitle;
  noCustomerText: string = config.noCustomerTitle;
  noEmailText: string = config.noEmail;
  usd = currency.USD;
  selectedPaymentMethod: any = {};
  previousCollectedAmount: number = 0;
  validate: any = {};
  remainingBalance: any = 0;
  remainingBalanceValidation: boolean = false;
  paymentId: any;
  reviewConfiguration: any;
  isLoadingResults: boolean = true;
  disabled: boolean = false;
  workFlowDisabled: boolean = false;
  isProcessing: boolean = false;
  isNewPayment: boolean = true;
  isOrderEditable: boolean = true;
  isCustomerEditable: boolean = true;
  paymentHistory: any = [];
  writeOffPaymentHistory: any = [];
  focus: any = { collectedAmount: false };
  paymentTypes: any[] = paymentTypes;
  paymentMethodsActive: any = {
    cheque: true,
    cash: true,
    card: true,
  };
  maxDateRange: any = new Date();
  activePayment: any = {};
  payRixResponse: any = {};
  globalPaymentResponse: any = {};
  payment: any = {
    _id: '',
    title: '',
    code: '',
    payrixResponse: this.payRixResponse,
    globalPaymentResponse: this.globalPaymentResponse,
    isOnline: false,
    paymentProvider: '',
    paymentType: '',
    collectedAmount: null,
    isPaidFull: false,
    workFlowPaid: false,
    customer: {
      customerId: '',
      chargeAccountDetails: {},
      chargeAccountEnable: {},
      fullName: '',
      email: '',
      phone: '',
    },
    vehicle: {
      vehicleId: '',
      name: '',
    },
    estimate: {
      estimateId: '',
      title: '',
      code: '',
      invCode: '',
      estimateBy: '',
      cash: 0,
      cheque: 0,
      card: 0,
      creditPayment: 0,
      thirdParty: 0,
      total: 0,
      isFinalized: false,
      finalizeType: '',
    },
    method: {
      methodId: '',
      qboId: '',
      name: '',
      type: '',
    },
    cardType: '',
    card4Digits: '',
    cardConfNo: '',
    checkNo: '',
    notes: '',
    thirdPartyVendor: '',
    creditMemoNumber: '',
  };
  isSearching: boolean = false;
  paymentTime: any = '';
  isQboConnected: any = false;
  collectedAmount: any;
  partialPayment: any;
  confirmCardPattern: any = { '0': { pattern: new RegExp('[a-zA-Z0-9]') } };
  isConfigLoading: boolean = false;
  isPaymentLoading: boolean = false;
  isMethodLoading: boolean = false;
  enableMandatoryVin: boolean = false;
  orderVehicle: any;
  isPaymentOnline = false;
  showNotes = true;
  dataServiceSubscription: Subscription;
  win: any;
  opening = false;
  featureIsPayRixEnable: boolean;
  isPayrixConnected: Boolean;
  defaultPaymentTime: any = '';
  availableCredits: any[] = [];
  isGlobalPayEnabled: boolean = false;
  isGlobalPayConnected: boolean = false;
  isGlobalPayCardSwipConnected: boolean = false;
  isCustomerPaymentEnabled: boolean = false;
  merchantId: string;
  apiKey: string;
  //  to show card drop down, confirmation and last 4 digits
  afterOnlinePayment = false;
  terminalList: any[] = [];
  isSwipeOnline: boolean = false;
  activeTerminal: any;
  selectedTerminal: {
    isTransactionPending: any;
    name: string;
    id: string;
  };
  afterSwipePayment: boolean = false;
  isServicePending: boolean = false;
  isLockOrderEnabled: boolean = false;
  isInvoiceLockEnabled: boolean = false;
  isOrderLocked: boolean = false;
  orderRestriction = { employeeName: '', token: '', status: '', employeeFirstName: '', employeeLastName: '' };
  swapAmount: string = '';
  isCalculateChangeEnabled: boolean = false;
  isInvoiceLockOn: boolean = false;
  isRevenueRecognitionSettleEnabled: boolean = false;
  isWriteOffEnable: boolean = false;
  currentTime: Date;
  isFinalizedSectionVisible: boolean = false;
  allPaymentHistory: any[] = [];
  allRefunds: Number = 0;
  isFetchingPaymentHistory: boolean = false;
  isFetchingEstPayment: boolean = false;
  isFetchingCreditMemos: boolean = false;
  isFetchingCustomerInfo: boolean = false;
  hasUserPermissionToFinlize: boolean = false;
  chargeAccountDetails: any = {};
  defaltChargeAccountLimit: any = {};
  estiamteToChargeAccount: any = {};
  isChargeAccountEnabled: boolean = false;
  customer: any;
  customerId: string = '';
  private credentials: paymentObject;
  private socketListner: Subject<boolean> = new Subject<boolean>();
  private transactionDialogue: DynamicDialogRef;
  private isSwipeRequestPending: boolean = false;
  changePaymentData: boolean = false;
  isPaymentDataPrivilgesEnabled: boolean = false;
  isEditMode: boolean = false;
  thirdPartyAssociatedVendors: any[] = [];
  thirdPartyPaymentMethods: any[] = [];
  isFinalizedRO: boolean = false;
  isFinalizedAsThirdParty: boolean = false;
  finalizeDetails: any = {};
  isOpenFromTopNav: boolean = false;
  isOpenFromKanban: boolean = false;
  isOpenFromRO: boolean = false;
  //writeOffRemainingBalance: number = 0;
  //writeOffAmount: Number = 0;
  writeOffPaymentMethods: any[] = [];
  writeOffPayment: number = 0;
  overAgePayment: number = 0;
  unPaid: number = 0;

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    public validationService: ValidationService,
    public dataService: DataService,
    public dateService: DateService,
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private calculationService: CalculationService,
    private cdr: ChangeDetectorRef,
    private socket: SocketService,
    private formatService: FormatService,
  ) {
    const data = this.dConfig.data;
    const { isRevenueRecognitionSettleEnabled } = this.helperService.getCompany();
    this.defaltChargeAccountLimit = this.dataService.chargeAccounts;
    this.featureIsPayRixEnable = this.dataService.isPrimaryPaymentPayrix;
    this.isPayrixConnected = this.dataService.isPayrixConnected;
    this.isCalculateChangeEnabled = this.dataService.isCalculateChangeEnabled;
    this.isGlobalPayEnabled = this.dataService.isPrimaryPaymentGlobalPay;
    this.isGlobalPayConnected = this.dataService.isGlobalPayConnected;
    this.isGlobalPayCardSwipConnected = this.dataService.isGlobalPaySwipeConnected;
    this.isCustomerPaymentEnabled = this.dataService.isCustomerPaymentEnabled;
    this.isChargeAccountEnabled = this.dataService.isChargeAccountEnabled;
    this.isWriteOffEnable = this.dataService.isWriteOffEnable;
    this.isRevenueRecognitionSettleEnabled = isRevenueRecognitionSettleEnabled;
    this.isFinalizedSectionVisible = data?.estimate?.dialogType === 'add-payment-finalized-dialog' && this.isRevenueRecognitionSettleEnabled;
    this.hasUserPermissionToFinlize = this.dataService.isArAccountManagement;
    this.customerId = data?.estimate?.customer?.customerId;
    this.paymentId = data?.paymentId || '';
    this.isEditMode = data?.isEditMode || false;

    if (data?.isOpenFromKanban) this.isOpenFromKanban = data.isOpenFromKanban;
    else if (data?.isOpenFromRO) this.isOpenFromRO = data.isOpenFromRO;
    else if (data?.isOpenFromTopNav) this.isOpenFromTopNav = data.isOpenFromTopNav;

    if (this.isChargeAccountEnabled) {
      this.estiamteToChargeAccount = data?.estimate?.fulEstimateObject;
    }

    if (this.isFinalizedSectionVisible) {
      this.paymentTypes = [
        ...this.paymentTypes,
        {
          value: 'creditPayment',
          label: 'Credit Memo',
          icon: 'fal fa-usd-circle',
          active: true,
          disabled: !this.availableCredits?.length,
          tooltip: "Customer doesn't have any Credit Memo",
        },
      ];
      this.addPaymentTypes();
    }

    if (this.featureIsPayRixEnable && this.isPayrixConnected) {
      this.httpService.getPayrixInfo().then((data: any) => {
        if (data) {
          const { hash } = data;

          if (hash !== '') {
            this.credentials = this.helperService.decryptPaymentData(hash);
            this.merchantId = this.credentials.merchantId;
            this.apiKey = this.credentials.apiKey;

            this.getTerminals();
          }
        }
      });
    }

    if (this.isGlobalPayCardSwipConnected || (this.isGlobalPayConnected && this.isGlobalPayEnabled)) {
      this.httpService.getGlobalPaymentInfo().then((data: any) => {
        if (data) {
          const { hash } = data;

          if (hash !== '') {
            this.credentials = this.helperService.decryptPaymentData(hash);
          }
        }
      });
      this.getTerminals();
    }
  }

  addPaymentTypes() {
    let index = findIndex(this.paymentTypes, { value: 'thirdParty' });
    if (index < 0) {
      index = findIndex(this.paymentTypes, { value: 'cheque' });
      if (index > -1) {
        this.paymentTypes.splice(index + 1, 0, {
          value: 'thirdParty',
          label: '3rd Party',
          icon: 'fal fa-store',
          active: true,
          disabled: false,
          tooltip: 'This RO is not finalized as 3rd party account',
        });

        if (this.isWriteOffEnable) {
          this.paymentTypes.splice(findIndex(this.paymentTypes, { value: 'thirdParty' }) + 1, 0, {
            value: 'writeOff',
            label: 'Write-off',
            icon: 'fal fa-money-check-edit',
            active: true,
            disabled: false,
            tooltip: 'This RO is not finalized',
          });
        }

        //this.paymentMethodsActive.thirdPartyPayment = true,
        //this.paymentMethodsActive.writeOff = true;
      }
    }
  }

  ngOnInit() {
    const user = this.helperService.getCompany();
    this.socket
      .socketOn(`PAYMENT_UPDATE_MODAL_${user.shopId}`)
      .pipe(takeUntil(this.socketListner))
      .subscribe((payment: SocketPayment) => {
        if (payment.orderId !== this.payment.estimate.estimateId) return;
        if (payment.data.error) {
          this.helperService.showToaster('error', payment.data.msg);
          this.transactionDialogue.close(false);
          this.isProcessing = false;
          return;
        }
        this.payment.card4Digits = payment.data.socketPayload.last4Digit;
        this.payment.cardConfNo = payment.data.socketPayload.confirmationNum;
        this.payment.collectedAmount = payment.data.socketPayload.collectedAmount;
        this.payment.amount = payment.data.socketPayload.actualAmount;
        this.payment.updatedAt = payment.data.socketPayload.updatedAt;
        this.payment.isOnline = true;
        this.payment.paymentProvider = 'payrix';

        if (!this.isRevenueRecognitionSettleEnabled) {
          this.afterOnlinePayment = true;
          this.afterSwipePayment = true;
        }

        this.showNotes = true;
        this.paymentId = payment.data.socketPayload.paymentId;

        this.isProcessing = false;
        this.helperService.showToaster('success', messages.paymentCreated);
        this.onCardTypeSelect(payment.data.socketPayload.paymentMethod);
        this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
        this.transactionDialogue.close();
        if (payment.data.socketPayload.isPartialPaymentApproved) {
          this.payment.isPaidFull = false;
          this.partialPaymentApproved(this.payment);
        }
      });
    const data = this.dConfig.data;
    this.getReviewConfiguration();
    this.fetchPaymentMethods();
    this.isQboConnected = this.helperService.getCompany().qbo;

    if (data) {
      this.isNewPayment = data.isNewPayment;
      this.isCustomerEditable = data.isNewPayment;
      this.isOrderEditable = data.isNewPayment;
      //moving to constructor as flow is dependant on payment id Fix -ALP- 14635 issue #4
      //this.paymentId = data.paymentId ? data.paymentId : '';
      const estimate = data.estimate ? data.estimate : '';
      const vehicleInfo = data?.estimate?.vehicleInfo;

      if (this.paymentId) {
        this.getPaymentDetails();
      }

      if (estimate) {
        this.setFinalizedData(estimate);
        this.setEstimateDetails(estimate);
        this.getPaymentHistory(estimate._id);
      }

      if (vehicleInfo) {
        if (vehicleInfo?.vin === '' || vehicleInfo?.milage === '' || vehicleInfo?.milageOut === '' || !estimate?.authorized) {
          this.isNotVehicleInfo = true;
        }
      }
    }

    this.setDataService();
    if (data.estimate && data.estimate._id) {
      this.checkSwapPendingService(data.estimate._id);
    }
    if (this.isChargeAccountEnabled) {
      // this.getCustomerChargeAccountInfo();
    }
  }

  reloadValuesWithLatestData(estimate: any) {
    const vehicleInfo = estimate?.vehicleInfo;
    this.setFinalizedData(estimate);
    this.fetchPaymentMethods();

    if (estimate) {
      this.setFinalizedData(estimate);
      this.setEstimateDetails(estimate);
      this.getPaymentHistory(estimate._id);
    }
    if (vehicleInfo) {
      if (vehicleInfo?.vin === '' || vehicleInfo?.milage === '' || vehicleInfo?.milageOut === '' || !estimate?.authorized) {
        this.isNotVehicleInfo = true;
      }
    }
    if (estimate && estimate._id) {
      this.checkSwapPendingService(estimate._id);
    }
  }

  setFinalizedData(estimate: any) {
    this.isFinalizedRO = estimate?.fulEstimateObject?.isFinalized || estimate?.isFinalized || false;
    this.isFinalizedAsThirdParty = estimate?.fulEstimateObject?.finalizeType === 'thirdPartyAccounts' || estimate?.finalizeType === 'thirdPartyAccounts' || false;
    if (this.isFinalizedRO && this.isFinalizedAsThirdParty) {
      this.finalizeDetails = estimate?.fulEstimateObject?.finalizeDetails?.thirdPartyAccount || estimate?.finalizeDetails?.thirdPartyAccount;
    }
  }

  async checkSwapPendingService(id, showOnlyToast = false) {
    const data = await this.httpService.isSwipeRequestPending(id);
    if (data) {
      this.isSwipeRequestPending = data && data.isSwipeRequestPending;
      if (this.isSwipeRequestPending) {
        this.swapAmount = data.swipeAmt;
        if (showOnlyToast) {
          this.helperService.showToaster('error', 'A payment against this RO is already in progress. Please try again later.');
          return;
        }
        this.closePaymentModal({ isSuccess: false }, true);
        this.showProgressModal();
      }
    }
  }

  showProgressModal() {
    this.transactionDialogue = this.dialogService.open(SwipeCardConfirmationComponent, {
      width: '30%',
      closeOnEscape: false,
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        isProcessing: true,
        amount: this.isSwipeRequestPending ? this.swapAmount : this.payment.collectedAmount,
        id: this.payment.estimate.estimateId,
        isGlobalPayment: this.isGlobalPayEnabled ? true : false,
      },
    });
    if (!this.isGlobalPayEnabled) {
      this.ref.close();
    }
  }

  getTerminals(): void {
    if (this.isPayrixConnected && this.featureIsPayRixEnable) {
      this.httpService.getTerminalListForOnlinePayment(this.merchantId).then((r) => {
        this.terminalList = r.data
          .map((e) => {
            // if (e.isTransactionPending) {
            //   return;
            // }
            return {
              name: e.name,
              id: e.id,
              isTransactionPending: e.isTransactionPending,
              pendingRo: e.pendingRo,
              disabled: e.isTransactionPending ? true : false,
            };
          })
          .filter((x) => x);
      });
    } else if (this.isGlobalPayCardSwipConnected) {
      this.httpService.globalPaymentGetTerminalList().then((r) => {
        this.terminalList = r
          .map((e) => {
            // if (e.isTransactionPending) {
            //   return;
            // }
            return {
              name: e.deviceName,
              deviceId: e.deviceId,
              id: e._id,
              isTransactionPending: e.isTransactionPending ? true : false,
              pendingRo: e.pendingRo ? true : false,
              disabled: e.isTransactionPending ? true : false,
            };
          })
          .filter((x) => x);
      });
    }
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }

    this.socketListner.next(true);
    this.socketListner.unsubscribe();
  }

  setDataService() {
    this.enableMandatoryVin = this.dataService.enableMandatoryVin;
    this.isLockOrderEnabled = this.dataService.isLockOrderEnabled;
    this.isInvoiceLockEnabled = this.dataService.isInvoiceLockEnabled;
    this.isInvoiceLockOn = this.dataService.isInvoiceLockOn;
    this.changePaymentData = this.dataService.changePaymentData;
    this.isPaymentDataPrivilgesEnabled = this.dataService.isPaymentDataPrivilgesEnabled;

    this.dataServiceSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'company-appdata-updated') {
          this.enableMandatoryVin = this.dataService.enableMandatoryVin;
          this.isPayrixConnected = this.dataService.isPayrixConnected;
          this.isLockOrderEnabled = this.dataService.isLockOrderEnabled;
          this.isInvoiceLockEnabled = this.dataService.isInvoiceLockEnabled;
          this.isCalculateChangeEnabled = this.dataService.isCalculateChangeEnabled;
          this.isInvoiceLockOn = this.dataService.isInvoiceLockOn;
          this.changePaymentData = this.dataService.changePaymentData;
          this.isPaymentDataPrivilgesEnabled = this.dataService.isPaymentDataPrivilgesEnabled;
        }

        if (data.key === 'vehicle') {
          if (this.payment.vehicle) {
            this.payment.vehicle.VIN = data.data.vehicle.VIN;
          } else {
            this.orderVehicle.VIN = data.data.vehicle.VIN;
          }
        }

        if (data.key === 'update-order-customer-close' && this.orderVehicle._id) {
          this.isProcessing = true;
          this.httpService
            .getVehicleById(this.orderVehicle._id)
            .then((orderVehicle) => {
              this.orderVehicle = orderVehicle && orderVehicle.vehicles;
            })
            .finally(() => {
              this.isProcessing = false; //git checkout
            });
        }

        if (data.key === 'update-finalize-modal-data' && data?.data?.estimate?._id) {
          this.reloadValuesWithLatestData(data.data.estimate);
        }

        if (data.key === 'get-customer-creditMemo') {
          this.getCustomerCreditMemos();
        }

        // if (data.key === 'refetch-order-to-finalize') {
        //   this.setEstimateDetails({ _id: this.payment?.estimate?.estimateId });
        // }
      }
    });
  }

  async getCustomerCreditMemos() {
    try {
      this.isFetchingCreditMemos = true;
      const estimateId = this.payment?.estimate?.estimateId;
      let customerId = this.payment?.customer?.customerId;
      if (typeof customerId === 'object') {
        customerId = customerId?._id;
      }

      const creditMemo: any = await this.httpService.getAllCreditMemo(customerId, true, estimateId);

      if (creditMemo?.length) {
        // this.payment.collectedAmount = 0;
        this.availableCredits = this.formatService.formatCustomerCreditMemo(creditMemo);

        if (this.availableCredits?.length && this.activePayment.value === 'creditPayment') {
          this.payment.collectedAmount = this.availableCredits.map((memo) => memo.remainingAmount).reduce((acc, val) => acc + val);
        }
      }

      const index = findIndex(this.paymentTypes, { value: 'creditPayment' });

      if (index !== -1) {
        if (this.availableCredits?.length) {
          this.paymentTypes[index].disabled = false;
        } else {
          this.paymentTypes[index].disabled = true;
        }
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isFetchingCreditMemos = false;
    }
  }

  async getCustomerChargeAccountInfo() {
    if (this.customerId) {
      try {
        this.isFetchingCustomerInfo = true;
        const customer: any = await this.httpService.getCustomerChargeAccountDetails(this.customerId, { chargeAccountDetails: true });

        if (customer?.chargeAccountDetails) {
          this.customer = customer;
          let allowedLimit = this.customer.chargeAccountDetails?.allowedLimit || 0;
          let unlimited = this.customer.chargeAccountDetails?.unlimited || false;
          if (!allowedLimit && !unlimited) {
            if (this.customer.isFleetCustomer) {
              allowedLimit = this.defaltChargeAccountLimit?.fleetCustomerLimit?.value;
              unlimited = this.defaltChargeAccountLimit?.fleetCustomerLimit?.unlimited;
            } else {
              allowedLimit = this.defaltChargeAccountLimit?.regularCustomerLimit?.value;
              unlimited = this.defaltChargeAccountLimit?.fleetCustomerLimit?.unlimited;
            }
          }
          if (typeof this.customer?.chargeAccountDetails?.usedLimit === 'undefined') {
            this.customer.chargeAccountDetails.usedLimit = 0;
          }
          this.chargeAccountDetails = {
            allowedLimit,
            usedLimit: this.customer?.chargeAccountDetails?.usedLimit,
            unlimited,
            availableLimit: allowedLimit - this.customer?.chargeAccountDetails?.usedLimit,
          };
        }
      } catch (err) {
        this.helperService.showToaster('error', err);
      } finally {
        this.isFetchingCustomerInfo = false;
      }
    }
  }

  async getPaymentsHistory() {
    const estimateId = this.payment?.estimate?.estimateId;

    if (estimateId) {
      return;
    }

    try {
      const paymentHistory: any = await this.httpService.getPaymentHistoryByOrderId(estimateId);
      this.allPaymentHistory = this.formatService.formatPaymentsHistory(paymentHistory, true).paymentsHistory;
      // this.setPaymentHistory(history);
      // this.isFetchingPaymentHistory = false;
      this.cdr.detectChanges();
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
    }
    // this.isFetchingPaymentHistory = true;
    // this.httpService.getPaymentHistoryByOrderId(estimateId).then(
    //   (history: any[]) => {
    //     this.paymentHistory = [];
    //     this.setPaymentHistory(history);
    //     this.isFetchingPaymentHistory = false;
    //     this.cdr.detectChanges();
    //   },
    //   (err) => {
    //     this.isFetchingPaymentHistory = false;
    //     this.helperService.showToaster('error', err);
    //   }
    // );
  }

  /** Getting review configuration */
  getReviewConfiguration() {
    this.isConfigLoading = true;
    this.httpService.getReviewConfiguration().then(
      (configuration) => {
        this.currentTime = this.dateService.getCurrentDateTimeTz(configuration.serverTime);
        this.reviewConfiguration = configuration;
        this.paymentTime = this.dateService.getCurrentDateTimeTz(configuration.serverTime);
        this.defaultPaymentTime = this.paymentTime;
        // this.payment.paymentDate = this.dateService.getCurrentDateTimeTz(configuration.serverTime);
        if(!this.payment.paymentDate){
          this.payment.paymentDate = this.dateService.getCurrentDateTimeTz(configuration.serverTime);
        }
        const maxDateRange = this.dateService.getCurrentDateTimeTz(configuration.serverTime);
        this.maxDateRange = new Date(maxDateRange);
        this.isConfigLoading = false;

        if (!this.paymentId && this.isFinalizedSectionVisible) {
          this.getCustomerCreditMemos();
        }
      },
      (err) => {
        this.isConfigLoading = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  /** Getting payment details */
  getPaymentDetails() {
    if (!this.paymentId) return;
    this.isPaymentLoading = true;
    this.httpService.getPaymentById(this.paymentId).then(
      (payment: any) => {
        if (payment) {
          const estimate = payment.estimate?.estimateId;
          this.isInvoiceLocked = estimate?.isPaidFull && this.isInvoiceLockEnabled && estimate?.invoiceRestriction?.status === 'restricted';
          this.isArchived = estimate?.isArchived;
          this.setPaymentDetails(payment);
        }

        this.isPaymentLoading = false;
      },
      (err) => {
        this.isPaymentLoading = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  clearSearchResult(type: string) {
    this.isSearching = false;
    if (type === 'order') {
      this.estimateSearchResults = [];
    } else {
      this.customerSearchResults = [];
    }
  }

  toggleEditMode(type: string) {
    if (this.isNewPayment) {
      if (type === 'order') {
        this.isOrderEditable = !this.isOrderEditable;
      } else {
        this.isCustomerEditable = !this.isCustomerEditable;
      }
    }
  }

  /** Getting amount from the input box and calculating the remaining balance */
  handleChange(value: any, field: string) {
    if (field === 'collectedAmount') {
      this.payment[field] = !isNaN(value.replace(',', '')) ? Number(value.replace(',', '')) : value;
    } else if (field !== 'card4Digits' && field !== 'cardConfNo' && field !== 'checkNo' && field !== 'thirdPartyVendor' && field !== 'creditMemoNumber') {
      this.payment[field] = Number(value);
    } else {
      this.payment[field] = value;
    }

    this.calculateRemainingBalance();
    // if(this.isFinalizedSectionVisible) {
    //   this.calculateWriteOffRemaingAmount();
    // }
  }

  /** Calculate remaining amount */
  calculateRemainingAmount() {
    const { total, cash, card, cheque, creditPayment, thirdParty } = this.payment.estimate;
    let remaining = 0;
    const paid = sum([
      this.calculationService.roundOff(cash),
      this.calculationService.roundOff(card),
      this.calculationService.roundOff(cheque),
      this.calculationService.roundOff(creditPayment),
      this.calculationService.roundOff(thirdParty),
      this.calculationService.roundOff(this.writeOffPayment),
    ]);

    if (this.paymentId) {
      remaining = total + this.previousCollectedAmount - paid;
    } else {
      remaining = total - paid;
    }

    return this.calculationService.roundOff(remaining);
  }

  // calculateWriteOffRemaingAmount() {
  //   this.writeOffAmount = this.calculationService.roundOff(this.payment?.estimate?.total - (Math.abs(this.payment.estimate?.paid + this.payment.collectedAmount)));
  // }

  // calculateWriteOffRemainingBanlance() {
  //   this.calculateWriteOffRemaingAmount();
  //   this.writeOffRemainingBalance = this.calculationService.roundOff(this.payment?.estimate?.total - (Math.abs(this.payment.estimate?.paid)));
  //   return this.writeOffRemainingBalance;
  // }

  /** Calculate and set remaining amount */
  calculateRemainingBalance() {
    this.collectedAmount = -1;
    const { total = 0, cash = 0, card = 0, cheque = 0, unpaid = 0, creditPayment = 0, thirdParty = 0 } = this.payment.estimate;
    const amount = this.payment.collectedAmount;
    const remainingAmount = this.calculateRemainingAmount();
    const paid = sum([
      this.calculationService.roundOff(cash),
      this.calculationService.roundOff(card),
      this.calculationService.roundOff(cheque),
      this.calculationService.roundOff(creditPayment),
      this.calculationService.roundOff(thirdParty),
      this.calculationService.roundOff(this.writeOffPayment),
    ]);

    if (amount && amount <= remainingAmount) {
      if (this.paymentId) {
        this.remainingBalance = total + this.previousCollectedAmount - (amount + paid);
      } else {
        this.remainingBalance = total - (amount + paid);
      }

      this.remainingBalance = this.calculationService.roundOff(this.remainingBalance);
      this.validate.amount = '';
    } else if (!amount) {
      if (this.paymentId) {
        this.remainingBalance = total + this.previousCollectedAmount - ((amount || 0) + paid);
        this.remainingBalance = this.calculationService.roundOff(this.remainingBalance);
      } else {
        this.remainingBalance = total - ((amount || 0) + paid);
        this.remainingBalance = this.calculationService.roundOff(this.remainingBalance);
      }
    } else {
      if (!this.isFinalizedAsThirdParty || (this.activePayment.value && this.activePayment.value !== 'thirdParty')) {
        this.validate.amount = '* Amount must be less than the remaining balance';
        this.collectedAmount = 0;
      }
      this.remainingBalance = this.calculateRemainingAmount();
    }

    if (this.remainingBalance < 0.45) {
      this.payment.isPaidFull = true;
      this.payment.workFlowPaid = true;
    } else {
      if (!this.disabled) {
        this.payment.isPaidFull = false;
      }

      if (!this.workFlowDisabled) {
        this.payment.workFlowPaid = false;
      }
    }

    if (this.isFinalizedSectionVisible && this.isFinalizedAsThirdParty && this.activePayment.value === 'thirdParty') {
      if (amount >= this.unPaid) {
        this.payment.isPaidFull = true;
        this.payment.workFlowPaid = true;
      }
    }
  }

  onEstimateSearch(value: string) {
    let query = '';
    query = `search=${value}&sort=createdAt&order=-1&activeOnly=false&limit=20&skip=0`;

    this.isSearching = true;
    this.httpService.estimateSearch(query).then(
      (estimates) => {
        if (estimates.records && estimates.records.length) {
          this.estimateSearchResults = estimates.records.map((estimate: any) => {
            return {
              ...estimate,
              isArchived: !estimate.isArchived,
              isActive: this.isOrderResctricted(estimate.restriction),
            };
          });
        }
        this.isSearching = false;
      },
      (err) => {
        this.isSearching = false;
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      },
    );
  }

  onCustomerSearch(event: string) {
    if (event) {
      this.httpService.searchCustomer(event.trim(), { limit: 50 }).then(
        (customer: any[]) => {
          const filter = customer;
          this.customerSearchResults = filter;
        },
        (err) => {
          this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
        },
      );
    } else {
      this.customerSearchResults = [];
    }
  }

  onEstimateSearchSelect(estimate) {
    estimate &&
      estimate.services.length > 0 &&
      estimate.services.forEach((item) => {
        if (item.serviceStatus === 'pending') {
          this.isServicePending = true;
        }
      });

    if (this.isServicePending) {
      this.closePaymentModal(estimate);
      this.helperService.showToaster('error', messages.authorizationMsg);
      this.helperService.openPageInNewExistingTab(`/estimate/${estimate._id}`, estimate._id);
      return;
    }

    this.isCustomerEditable = false;
    this.isOrderEditable = false;
    this.setEstimateDetails(estimate);
    this.checkSwapPendingService(estimate._id);
  }

  onCardTypeSelect(card: any) {
    this.payment.cardType = card.name;
    this.selectedPaymentMethod = card;
  }

  onCustomerSearchSelect(customer) {
    this.payment.customer = {
      customerId: customer._id,
      fullName: customer.fullName,
      phone: customer.phone,
      phone2: customer.phone2,
      displayName: customer.fullNameQBO,
      notes: customer.notes,
      companyName: customer.companyName,
      isFleetCustomer: customer.isFleetCustomer,
      email: customer.email,
    };
    this.isCustomerEditable = false;
    this.isOrderEditable = true;
    this.payment = {
      ...this.payment,
      isPaidFull: false,
      workFlowPaid: false,
      estimate: {
        estimateId: '',
        title: '',
        code: '',
        invCode: '',
        estimateBy: '',
        cash: 0,
        cheque: 0,
        card: 0,
        creditPayment: 0,
        thirdParty: 0,
        total: 0,
        isFinalized: false,
        finalizeType: '',
      },
    };
    this.estimateSearchResults = [];
    this.remainingBalance = 0;

    const query = `customerId=${customer._id}`;
    this.httpService.estimateSearch(query).then(
      (estimates) => {
        if (estimates.records && estimates.records.length) {
          this.estimateSearchResults = estimates.records;

          this.estimateSearchResults = this.estimateSearchResults.map((estimate: any) => {
            estimate.isActive = this.isOrderResctricted(estimate.restriction);
            return estimate;
          });
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onDateTimeChange(date: any) {
    this.payment.paymentDate = date;
  }

  closePaymentModal(data: any, isTransactionDone: boolean = false) {
    if (this.afterOnlinePayment || this.afterSwipePayment) {
      if (!isTransactionDone) {
        this.onSubmit(true);
      }
    }
    this.ref.close(data);
  }

  markPaymentComplete() {
    const hasRemaining = this.calculationService.roundOffToDecimalPlaces(this.calculateRemainingAmount() - this.payment.collectedAmount);
    if (hasRemaining) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          title: 'Mark RO as Paid',
          message: 'The amount entered is less then the total Order value, are you sure you want to continue?',
          button: {
            success: { title: 'Continue' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe((confirm) => {
        if (confirm.isSuccess) {
          this.payment._id = this.paymentId;

          if (this.paymentId) {
            this.updateTransaction();
          } else {
            this.createTransaction();
          }
        }
        onClose.unsubscribe();
      });
    } else {
      this.payment._id = this.paymentId;
      if (this.paymentId) {
        this.updateTransaction(true);
      } else {
        this.createTransaction();
      }
    }
  }

  handleFocus() {
    this.focus.collectedAmount = true;
    this.validate.amount = '';
    if (isNaN(this.payment.collectedAmount)) {
      this.payment.collectedAmount = 0;
    }
  }

  showSelected(type: string) {
    if (type === 'order') {
      if (this.payment.estimate && this.payment.estimate.estimateId) {
        this.isOrderEditable = false;
      }
    } else {
      if (this.payment.customer && this.payment.customer.customerId) {
        this.isCustomerEditable = false;
      }
    }
  }

  /** Getting paid full change */
  handleIsPaidChange(isPaidFull: boolean) {
    this.payment.isPaidFull = isPaidFull;
  }

  /** Getting workflow status change */
  handleworkFlowPaidChange(workFlowPaid: boolean) {
    this.payment.workFlowPaid = workFlowPaid;
  }

  displayNameEmail(fullName: string, email: string) {
    if (fullName && email) {
      return `${fullName} - ${email}`;
    } else if (fullName) {
      return `${fullName}`;
    }
  }

  /** Populate Estimate Details */
  setEstimateDetails(order: any) {
    const customer = order.customer || {};
    this.payment = {
      ...this.payment,
      customer: {
        customerId: customer?.customerId,
        fullName: customer?.fullName,
        email: customer?.email,
        phone: customer?.phone,
        phone2: customer?.phone2,
        notes: customer?.notes,
        displayName: customer?.displayName,
        isFleetCustomer: customer?.isFleetCustomer,
      },
      estimate: {
        estimateId: order._id,
        title: order?.title,
        code: order?.code,
        invCode: order?.invCode,
        workFlowStatus: order?.workFlowStatus?.name || '',
        isActive: order?.isActive,
        isFinalized: order?.isFinalized,
        finalizeType: order?.finalizeType,
        unpaid: order?.total?.unpaid,
      },
    };

    if (order?.vehicle?.vehicleId?._id) {
      this.orderVehicle = order.vehicle.vehicleId;
    }

    this.isFetchingEstPayment = true;
    this.httpService
      .getEstimatePaymentDetails(order._id)
      .then(
        (estimate: any) => {
          if (estimate.vehicle && estimate.vehicle.vehicleId) {
            this.orderVehicle = estimate.vehicle.vehicleId;
          }

          this.isInvoiceLocked = this.isInvoiceLockEnabled && estimate?.isPaidFull && estimate?.invoiceRestriction?.status === 'restricted';
          this.payment = {
            title: estimate.title,
            code: estimate.code,
            paymentType: {},
            collectedAmount: 0,
            isPaidFull: estimate.isPaidFull,
            workFlowPaid: estimate.workFlowStatus?.name,
            customer: {
              customerId: estimate.customer?.customerId,
              fullName: estimate.customer?.fullName,
              email: estimate.customer?.email,
              phone: estimate.customer?.phone,
              phone2: estimate.customer?.phone2,
              notes: estimate.customer?.notes,
              displayName: estimate.customer?.displayName,
              isFleetCustomer: estimate.customer?.isFleetCustomer,
            },
            estimate: {
              estimateId: estimate._id,
              title: estimate.title,
              code: estimate.code,
              invCode: estimate.invCode,
              orderStatus: estimate.orderStatus,
              estimateBy: '',
              workFlowStatus: estimate.workFlowStatus?.name || '',
              cash: this.calculationService.roundOff(estimate.cash),
              cheque: this.calculationService.roundOff(estimate.cheque),
              card: this.calculationService.roundOff(estimate.card),
              creditPayment: this.calculationService.roundOff(estimate.creditPayment),
              thirdParty: this.calculationService.roundOff(estimate.thirdParty),
              total: estimate.total.grand,
              totalDue: estimate.total.grand,
              unpaid: estimate.total.unpaid,
              createdAt: this.dateService.getCurrentDateTimeTz(new Date(estimate.backdatedCreationDate || estimate.createdAt).getTime()),
              isActive: this.isOrderResctricted(estimate.restriction),
              isFinalized: estimate.isFinalized,
              finalizeType: estimate.finalizeType,
              isPostToMyFleetCenter: estimate.isPostToMyFleetCenter,
              mfcInvoicePostedAt: estimate.mfcInvoicePostedAt,
              finalizeDate: estimate.finalizeDate,
              paid: sum([
                this.calculationService.roundOff(estimate.card),
                this.calculationService.roundOff(estimate.cash),
                this.calculationService.roundOff(estimate.cheque),
                this.calculationService.roundOff(estimate.creditPayment),
                this.calculationService.roundOff(estimate.thirdParty),
              ]),
              //overAgePayment: estimate?.total?.overAgePayment || order?.total?.overAgePayment || 0
            },
            paymentDate: this.paymentTime, // paymentTime is configured as server time
          };

          if (this.isFinalizedSectionVisible) {
            this.previousCollectedAmount = 0;
          }
          this.workFlowDisabled = this.payment.workFlowPaid === 'Paid';
          this.remainingBalance = this.calculateRemainingAmount();
          if (this.isRevenueRecognitionSettleEnabled) {
            this.payment.collectedAmount = 0;
          } else {
            this.payment.collectedAmount = this.calculationService.roundOff(this.remainingBalance);
          }

          this.calculateRemainingBalance();
          // if(this.isFinalizedSectionVisible) {
          //   this.calculateWriteOffRemainingBanlance();
          // }
          this.validate.amount = '';
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isFetchingEstPayment = false;
        this.isUnpaid();
      });
  }

  /** Populate Payment Details */
  setPaymentDetails(payment: any) {
    let estimate: any = {};
    const customer = payment.customer || {};

    if (payment?.estimate?.estimateId?._id) {
      estimate = payment.estimate.estimateId;
      estimate.estimateId = estimate._id;
    } else {
      estimate = payment.estimate || {};
    }

    this.paymentId = payment._id;
    this.payment = {
      _id: payment._id,
      title: estimate.title || '',
      code: estimate.code || '',
      refundToDate: payment.refundToDate || 0,
      refunds: payment.refunds || [],
      paymentType: payment.paymentType,
      notes: payment.notes,
      card4Digits: payment.card4Digits,
      cardConfNo: payment.cardConfNo,
      checkNo: payment.checkNo,
      collectedAmount: payment.amount,
      isPaidFull: estimate && estimate.isPaidFull && this.isNotVehicleInfo,
      workFlowPaid: estimate.workFlowStatus && estimate.workFlowStatus.name === 'Paid',
      transType :payment.transType,
      customer: {
        customerId: customer.customerId,
        fullName: customer.fullName,
        email: customer.email,
        phone: customer.phone,
        phone2: customer.phone2,
        notes: customer.notes,
        displayName: customer.displayName,
        isFleetCustomer: customer.isFleetCustomer,
      },
      paymentMethod: {
        methodId: payment.paymentMethod.methodId,
        qboId: payment.paymentMethod.qboId,
        name: payment.paymentMethod.name,
        type: payment.paymentMethod.type,
      },
      vehicle: payment.estimate.vehicle && payment.estimate.vehicle.vehicleId,
      estimate: {},
    };
    this.previousCollectedAmount = this.calculationService.roundOff(this.payment.collectedAmount);
    this.disabled = false;
    this.workFlowDisabled = this.payment.workFlowPaid;

    this.setPaymentMethod();

    if (estimate) {
      this.payment.estimate = {
        estimateId: estimate._id,
        code: estimate.code,
        invCode: estimate.invCode,
        title: estimate.title,
        cash: this.calculationService.roundOff(estimate.cash),
        cheque: this.calculationService.roundOff(estimate.cheque),
        card: this.calculationService.roundOff(estimate.card),
        creditPayment: this.calculationService.roundOff(estimate.creditPayment),
        thirdParty: this.calculationService.roundOff(estimate.thirdParty),
        total: this.calculationService.roundOff(estimate.total.grand),
        totalDue: this.calculationService.roundOff(estimate.total.grand),
        unpaid: this.calculationService.roundOff(estimate.total.unpaid),
        paid: this.calculationService.roundOff((estimate.total.grand || 0) - (estimate.total.unpaid || 0)),
        workFlowStatus: (estimate.workFlowStatus && estimate.workFlowStatus.name) || '',
        // createdAt: new Date(estimate.createdAt),
        createdAt: estimate.backdatedCreationDate
          ? this.dateService.getCurrentDateTimeTz(new Date(estimate.backdatedCreationDate).getTime())
          : this.dateService.getCurrentDateTimeTz(new Date(estimate.createdAt).getTime()),
        isActive: this.isOrderResctricted(estimate.restriction),
        isFinalized: estimate.isFinalized,
        finalizeType: estimate.finalizeType,
      };

      if (!!payment.paymentDate) {
        if (this.helperService.isAppleDevice()) {
          payment.paymentDate = this.dateService.madeDateStringIOSCompatible(payment.paymentDate);
        }

        this.payment.paymentDate = new Date(payment.paymentDate);
        this.paymentTime = new Date(payment.paymentDate);
      } else {
        this.payment.paymentDate = this.dateService.getCurrentDateTimeTz(new Date(payment.createdAt).getTime());
        this.paymentTime = this.payment.paymentDate;
      }
    }

    this.remainingBalance = this.calculateRemainingAmount();
    this.calculateRemainingBalance();
    // if(this.isFinalizedSectionVisible) {
    //   this.calculateWriteOffRemainingBanlance();
    // }
    if (this.payment.estimate?.estimateId) {
      this.getPaymentHistory(this.payment.estimate.estimateId);
    }
    if (this.afterOnlinePayment) {
      this.isInvoiceLocked = false; // in case of online payment added.
    }
  }

  setPaymentMethod() {
    if (this.payment.paymentMethod && this.payment.paymentMethod.methodId && this.paymentMethods.length) {
      // need to check mapping with integration type
      let [paymentMethod] = this.paymentMethods.filter(({ _id }) => _id === this.payment.paymentMethod.methodId);

      //  get payment methods after online payment
      if (this.afterOnlinePayment && this.paymentId && this.isGlobalPayConnected && this.isGlobalPayEnabled) {
        [paymentMethod] = this.globalPaymentMehod.filter(({ _id }) => _id === this.payment.paymentMethod.methodId);
      } else if (this.afterOnlinePayment && this.paymentId && this.isPayrixConnected && this.featureIsPayRixEnable) {
        [paymentMethod] = this.payrixPaymentMethod.filter(({ _id }) => _id === this.payment.paymentMethod.methodId);
      }

      const [activePaymentType] = this.paymentTypes.filter(({ value }) => this.payment.paymentType === value);

      if (paymentMethod && activePaymentType) {
        this.selectedPaymentMethod = paymentMethod;
        this.activateMethodCard(activePaymentType);
      }
    }
  }

  paymentMethod(data) {
    if (this.afterOnlinePayment) {
      return;
    } else {
      this.isPaymentOnline = data;
      this.isSwipeOnline = !data;
    }
    if ((this.featureIsPayRixEnable || this.isGlobalPayEnabled) && this.isPaymentOnline && !this.isSwipeOnline && this.activePayment.value === 'card') {
      this.showNotes = false;
    } else {
      this.showNotes = true;
    }
  }

  onChangenNote(event) {
    if (this.paymentId) {
      this.payment.customer.notes = event;
    }
  }

  activateMethodCard(method: any, changed = false) {
    if (!this.validateChangePaymentData() || !changed) {
      let isFirstTimeSelection = false;

      if (!this.activePayment?.value) {
        isFirstTimeSelection = true;
      }

      if (this.isPaymentTypeActive(method)) return;
      if (this.afterOnlinePayment || this.afterSwipePayment) {
        return;
      }

      if (method.value === 'card') {
        if (this.payment && this.payment.transType === 'manual') {
          this.isPaymentOnline = false;
          this.isSwipeOnline = false;
        } 
        else if (this.featureIsPayRixEnable || this.isGlobalPayEnabled) {
          if (this.featureIsPayRixEnable && this.terminalList?.length) {
            this.isPaymentOnline = true;
            this.isSwipeOnline = true;
            this.swipeCard(true);
          } else if (this.featureIsPayRixEnable && this.isPayrixConnected) {
            this.isPaymentOnline = true;
          } else if (this.isGlobalPayEnabled && this.terminalList?.length) {
            this.isPaymentOnline = true;
            this.isSwipeOnline = true;
            this.swipeCard(true);
          } else if (this.isGlobalPayEnabled && this.isGlobalPayConnected) {
            this.isPaymentOnline = true;
          } else {
            this.showNotes = true;
            this.isPaymentOnline = false;
          }
        }

        this.paymentMethods = [...this.cardPaymentMethods];
      } else if (method.value === 'cash') {
        this.isPaymentOnline = false;
        this.showNotes = true;
        this.paymentMethods = [...this.cashPaymentMethods];
      } else if (method.value === 'thirdParty') {
        this.isPaymentOnline = false;
        this.showNotes = true;
        this.paymentMethods = [...this.thirdPartyPaymentMethods];
      } else if (method.value === 'writeOff') {
        this.isPaymentOnline = false;
        this.showNotes = true;
        this.paymentMethods = [...this.writeOffPaymentMethods];
      } else {
        this.isPaymentOnline = false;
        this.showNotes = true;
        this.paymentMethods = [...this.otherPaymentMethods];
      }

      if (this.paymentMethods.length) {
        this.activePayment = method;
        if (changed) {
          if (this.isFinalizedRO && this.isFinalizedAsThirdParty && this.isFinalizedSectionVisible) {
            if (['thirdParty', 'writeOff'].includes(this.activePayment.value)) {
              if (this.activePayment.value === 'thirdParty') {
                this.selectedPaymentMethod = find(this.paymentMethods, { _id: this.finalizeDetails?.paymentMethodId });
                this.disableThirdPartyPaymentMethods();
                if (this.selectedPaymentMethod?.vendors?.length) {
                  this.thirdPartyAssociatedVendors = this.selectedPaymentMethod?.vendors;
                }
              } else if (this.activePayment.value === 'writeOff') {
                if (this.selectedPaymentMethod?.type !== 'WRITE_OFF') {
                  this.selectedPaymentMethod = {};
                }
              }
              this.validation(true);
              this.calculateRemainingBalance();
            }
          } else {
            this.selectedPaymentMethod = this.paymentMethods[0];
          }
        }
        if (this.isRevenueRecognitionSettleEnabled) {
          // Fixation of ALP-14478
          if (!changed && !this.isEditMode) {
            this.payment.collectedAmount = this.remainingBalance;
          }
          this.dataService.sendData(this.dataService.typePassData('reset-finalization-types', null));
        }
      }

      if (!this.paymentId && this.activePayment?.value === 'creditPayment') {
        this.payment.collectedAmount = 0;
      }

      if (isFirstTimeSelection && this.payment.collectedAmount === this.remainingBalance) {
        this.payment.isPaidFull = true;
        this.payment.workFlowPaid = true;
      }
    }
  }

  disableThirdPartyPaymentMethods() {
    if (this.paymentMethods?.length) {
      this.paymentMethods.forEach((method: any) => {
        if (this.selectedPaymentMethod?._id && this.selectedPaymentMethod?._id !== method?._id) {
          method.disabled = true;
        }
      });
    }
  }

  resetPaymentMethods() {
    if (this.isRevenueRecognitionSettleEnabled) {
      this.activePayment = {};
      this.selectedPaymentMethod = {};
      this.payment.collectedAmount = 0;
    }
  }

  /** Fetch payments and set the qboId for the non credit card payment */
  fetchPaymentMethods() {
    if (!environment.isMock) {
      this.isMethodLoading = true;
      this.httpService.getActivePaymentMethods().then(
        (paymentMethods: any[]) => {
          // payment Methods need to remove payrix and GP
          this.paymentMethods = paymentMethods.filter(({ integrationType }) => !integrationType);
          this.payrixPaymentMethod = paymentMethods.filter(({ integrationType }) => integrationType === 'payrix');
          this.globalPaymentMehod = paymentMethods.filter(({ integrationType }) => integrationType === 'globalPay');
          this.thirdPartyPaymentMethods = paymentMethods.filter(({ integrationType, type }) => !integrationType && type === 'THIRD_PARTY');
          this.writeOffPaymentMethods = paymentMethods.filter(({ integrationType, type }) => !integrationType && type === 'WRITE_OFF');

          this.paymentMethods.forEach((method) => {
            if (method.type === 'THIRD_PARTY') return;
            if (method.type === 'WRITE_OFF') return;

            if (method.type === 'CREDIT_CARD') {
              this.cardPaymentMethods.push(method);
            } else if (method.type === 'CASH' && !this.isQboConnected) {
              this.cashPaymentMethods.push(method);
            } else if (method.name.toLowerCase().includes('cash') && this.isQboConnected) {
              this.cashPaymentMethods.push(method);
            } else {
              this.otherPaymentMethods.push(method);
            }
          });

          // this.paymentMethodsActive = {
          //   card: !!this.cardPaymentMethods.length,
          //   cash: !!this.cashPaymentMethods.length,
          //   cheque: !!this.otherPaymentMethods.length,
          // };
          // this.paymentMethodsActive.card = !!this.cardPaymentMethods.length;
          // this.paymentMethodsActive.cash = !!this.cashPaymentMethods.length;
          // this.paymentMethodsActive.cheque = !!this.otherPaymentMethods.length;
          // this.paymentMethodsActive.thirdPartyPayment = (!!this.thirdPartyPaymentMethods.length) && (this.isFinalizedRO && this.isFinalizedAsThirdParty);
          // this.paymentMethodsActive.writeOff = (!!this.thirdPartyPaymentMethods.length) && (this.isFinalizedRO && this.isFinalizedAsThirdParty);

          this.applyPaymentTypeValidations();

          if (!this.paymentId && this.cashPaymentMethods.length && !this.isRevenueRecognitionSettleEnabled) {
            this.selectedPaymentMethod = this.cashPaymentMethods[0];
            this.activateMethodCard(this.paymentTypes[0]);
          }

          if (!this.paymentId) {
            // if (this.cashPaymentMethods.length) {
            //   this.selectedPaymentMethod = this.cashPaymentMethods[0];
            //   this.activateMethodCard(this.paymentTypes[0]);
            // } else if (this.cardPaymentMethods.length) {
            //   this.selectedPaymentMethod = this.cardPaymentMethods[0];
            //   this.activateMethodCard(this.paymentTypes[1]);
            // } else if (this.otherPaymentMethods.length) {
            //   this.selectedPaymentMethod = this.otherPaymentMethods[0];
            //   this.activateMethodCard(this.paymentTypes[2]);
            // }
          }
          this.isMethodLoading = false;
          this.setPaymentMethod();
        },
        (err) => {
          this.isMethodLoading = false;
          this.helperService.showToaster('error', err);
        },
      );
    }
  }

  applyPaymentTypeValidations() {
    this.paymentMethodsActive.card = !!this.cardPaymentMethods.length;
    this.paymentMethodsActive.cash = !!this.cashPaymentMethods.length;
    this.paymentMethodsActive.cheque = !!this.otherPaymentMethods.length;
    this.paymentMethodsActive.thirdParty = !!this.thirdPartyPaymentMethods.length && this.isFinalizedRO && this.isFinalizedAsThirdParty;
    this.paymentMethodsActive.writeOff = !!this.writeOffPaymentMethods.length && this.isFinalizedRO;

    if (this.isFinalizedSectionVisible && this.isFinalizedRO && this.isFinalizedAsThirdParty) {
      this.paymentMethodsActive.card = false;
      this.paymentMethodsActive.cash = false;
      this.paymentMethodsActive.cheque = false;
    }
  }

  /** Fetching payment history */
  getPaymentHistory(estimateId: string) {
    if (this.isFetchingPaymentHistory) {
      return;
    }

    this.isFetchingPaymentHistory = true;
    this.httpService.getPaymentHistoryByOrderId(estimateId).then(
      (history: any[]) => {
        this.paymentHistory = [];
        this.setPaymentHistory(history);
        this.isFetchingPaymentHistory = false;
        this.cdr.detectChanges();
      },
      (err) => {
        this.isFetchingPaymentHistory = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  setPaymentHistory(history: any[]) {
    if (history && history.length >= 0) {
      this.writeOffPayment = 0;
      this.paymentHistory = [...history];
      this.allRefunds = 0;
      this.paymentHistory.forEach((payment) => {
        if (!!payment.paymentDate) {
          payment.createdAt = new Date(payment.paymentDate);
        } else {
          payment.createdAt = this.dateService.getCurrentDateTimeTz(new Date(payment.createdAt).getTime());
        }
        // need this flag in tooltip
        payment.tooltip = this.helperService.createPaymentLogTooltip(payment);

        if (payment?.paymentType === 'thirdParty') {
          payment.thirdPartyName = `3rd party - ${payment?.paymentMethod?.name || ''}`;
        }

        if (payment?.paymentType === 'writeOff') {
          payment.writeOffName = `Write-off - ${payment?.paymentMethod?.name || ''}`;
        }

        this.allRefunds = this.allRefunds + payment.refundToDate;

        payment.refunds.map((refund) => {
          refund.tooltip = this.helperService.createRefundTooltip(refund, payment);
          refund.refundDate = this.dateService.getCurrentDateTimeTz(new Date(refund.refundDate).getTime());
          refund.isVoidPayment = refund.isVoid;
          return refund;
        });

        // sort refunds
        payment.refunds = orderBy(payment.refunds, ['refundDate'], 'desc');

        if (payment.isCreditPayment) {
          payment.paymentHistory.map((credit) => {
            payment.creditMethodType = credit.paymentMethod.replace('Memo', 'Memo Applied');
          });
        }
        this.calulateWriteOfPayment(payment);
      });
      this.calculateRemainingBalance();
      this.getOverAgePayment();
      this.segrigatePaymentHistoryArray();
    }
    this.isUnpaid();
  }

  segrigatePaymentHistoryArray() {
    this.writeOffPaymentHistory = this.paymentHistory?.filter((history: any) => history?.paymentType === 'writeOff');
    const historyArray: any[] = this.paymentHistory?.filter((history: any) => history?.paymentType !== 'writeOff');
    this.paymentHistory = historyArray;
  }
  isUnpaid() {
    if (this.isFinalizedAsThirdParty) {
      this.unPaid = this.overAgePayment + this.payment?.estimate?.unpaid - this.writeOffPayment;
    } else {
      this.unPaid = this.payment?.estimate?.unpaid - this.writeOffPayment;
    }
  }

  getOverAgePayment() {
    if (this.paymentHistory?.length) {
      const overAgePaymentObj: any = find(this.paymentHistory, (payment: any) => {
        if (payment.paymentType === 'thirdParty' && payment.overAgePayment > 0) {
          return payment;
        }
      });

      if (overAgePaymentObj?.overAgePayment) {
        this.overAgePayment = overAgePaymentObj?.overAgePayment;
      }
    }
  }

  calulateWriteOfPayment(payment: any) {
    if (payment?.paymentType === 'writeOff') {
      this.writeOffPayment += this.calculationService.roundOff(payment?.amount);
    }
  }

  /** Validate payment data */
  validation(isCallFromActivate: boolean = false) {
    this.focus.collectedAmount = false;
    if (this.payment.collectedAmount === '.') {
      this.payment.collectedAmount = 0;
    }
    let isFormValid = true;
    this.validate = {};

    if (this.selectedPaymentMethod?.name?.toLowerCase() === 'check' && this.activePayment.value === 'cheque' && !this.payment.checkNo) {
      this.helperService.showToaster('error', `Please add ${this.dataService.checkTxt} number`);
      isFormValid = false;
    }

    if (this.payment.estimate.estimateId === '') {
      this.validate.estimate = '* Please enter estimate';
      isFormValid = false;
    }

    if (!this.isCustomerPaymentEnabled && this.payment.collectedAmount > this.calculateRemainingAmount()) {
      if (!this.isFinalizedAsThirdParty || this.activePayment?.value !== 'thirdParty') {
        this.validate.amount = '* Amount must be lesser than remaining balance';
        isFormValid = false;
      }
    }

    if (this.activePayment?.value === 'writeOff' && this.payment.collectedAmount > this.calculateRemainingAmount()) {
      this.validate.amount = '* Amount must be lesser than remaining balance';
      isFormValid = false;
    }

    if (this.payment.refundToDate > this.payment.collectedAmount) {
      this.validate.amount = '* Payment amount must be greater then Refunds';
      isFormValid = false;
    }

    if (!this.selectedPaymentMethod || (this.selectedPaymentMethod && !this.selectedPaymentMethod._id)) {
      if (!isCallFromActivate) {
        this.validate.paymentMethod = '* Payment select payment method';
      }
      isFormValid = false;
    }

    if (this.payment.paymentDate && this.paymentTime) {
      const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
      const time = this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm);
      let paymentDate: any = new Date(`${date} ${time}`);

      if (this.helperService.isAppleDevice()) {
        paymentDate = new Date(this.dateService.madeDateStringIOSCompatible(`${date} ${time}`));
      } else {
        paymentDate = new Date(`${date} ${time}`);
      }

      if (paymentDate === 'Invalid Date') {
        this.helperService.showToaster('error', `Please select a valid date`);
        return false;
      } else {
        const estimateCreationDate = new Date(this.payment.estimate.createdAt);
        estimateCreationDate.setSeconds(0);
        estimateCreationDate.setMilliseconds(0);

        if (this.payment.estimate && estimateCreationDate.getTime() > paymentDate.getTime()) {
          this.helperService.showToaster('error', `The payment cannot be received before RO was created ${this.dateService.formatDate(this.payment.estimate.createdAt, datetimeFormat.mmmdyyhhmmaa)}`);
          isFormValid = false;
        }
      }
    }

    return isFormValid;
  }

  async onSubmit(isForced: boolean = false) {
    if (this.featureIsPayRixEnable) {
      await this.checkSwapPendingService(this.payment.estimate.estimateId, true);
    }
    if (!this.isSwipeRequestPending) {
      if (this.isProcessing || this.isConfigLoading || this.isPaymentLoading || this.isMethodLoading) {
        return;
      }
      if (this.activePayment.value === 'card' && this.isPaymentOnline && !this.afterOnlinePayment && !this.paymentId && this.isSwipeOnline && !this.afterSwipePayment) {
        this.helperService.showToaster('error', 'Please complete your payment');
        return;
      }
      if (this.enableMandatoryVin && (!this.orderVehicle?.VIN || !this.payment?.vehicle?.VIN) && !isForced) {
        this.handleVinPrompt({
          title: `Add VIN to Invoice RO`,
          message: `${this.orderVehicle ? this.orderVehicle.name : this.payment.vehicle.name} does not contain VIN. Please enter the VIN before Invoicing.`,
          success: 'Enter VIN',
          cancel: 'Add payment',
          type: 'invoice',
        });
        return;
      }
      if (this.validation()) {
        this.payment.amount = Number(this.payment.collectedAmount);

        if (this.payment.isPaidFull && !this.isNotVehicleInfo && !this.isFinalizedAsThirdParty) {
          this.markPaymentComplete();
        } else {
          if (this.paymentId) {
            this.updateTransaction();
          } else {
            // if (this.activePayment.value === 'creditPayment') {
            //   this.createCreditPayment();
            // } else {
            // }
            this.createTransaction();
          }
        }

        if (this.payment?.estimate?.isPostToMyFleetCenter) {
          this.sendPostGainInsight();
        }

        if (this.activePayment.value == 'writeOff') {
          const payload = {
            RoNumber: this.payment?.estimate?.code,
            WriteOffAmount: this.payment.collectedAmount,
            WriteOffType: this.selectedPaymentMethod.name,
            PaymentDate: this.payment.paymentDate,
            RoTotal: this.payment.estimate.total,
          };
          this.helperService.postGainsightPXEvent('Write-off Applied', payload);
        }

        this.dataService.sendData(this.dataService.typePassData('sent-to-ar', { data: 'refecth data' }));
      }
    }
  }

  sendPostGainInsight() {
    let event = 'Payment collected on a MyFleetCenter invoice';
    const payment = this.payment;
    const estimate = payment?.estimate;
    const selectedPaymentMethod = this.selectedPaymentMethod;
    let payload = {
      'Posted to MyFleetCenter date': estimate?.mfcInvoicePostedAt,
      'Fleet type (local / national)': payment?.customer?.customerId?.MFC?.accountType,
      'RO#': estimate?.code,
      'Invoice#': estimate?.invCode,
      'Posted to MyFleetCenter (YES / NO)': estimate?.isPostToMyFleetCenter ? 'YES' : 'NO',
      'Finalization date': estimate?.finalizeDate,
      'Finalization type': estimate?.finalizeType,
      'Paid (amount)': estimate?.paid,
      'Payment object(s)': {
        'Payment type': selectedPaymentMethod?.type,
        'Payment method': selectedPaymentMethod?.name,
        'Payment amount': payment?.amount,
        'Payment date': payment?.paymentDate,
      },
    };
    this.helperService.postGainsightPXEvent(event, payload);
  }

  handleVinPrompt({ title, message, success, cancel, type, payload }: any) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title,
        message,
        button: {
          success: { title: success },
          cancel: { title: cancel },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        const vehicle = this.orderVehicle ? this.orderVehicle : this.payment.vehicle;

        if (!vehicle) return;

        if (!vehicle.vehicleId) vehicle.vehicleId = vehicle._id;

        const customer = this.payment.customer;
        customer._id = customer.customerId;

        customer.vehicleId = vehicle.vehicleId;
        customer.highLightedVIN = true;
        this.dataService.sendData(this.dataService.typeSidebar('vehicle', customer.customerId, customer.fullName, customer));
      } else {
        if (data.btn === 'close') return;
        this.onSubmit(true);
      }

      onClose.unsubscribe();
    });
  }

  /** Update payment transaction */
  updateTransaction(isPaymentDelete = false) {
    this.payment._id = this.paymentId;
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;

    this.payment.paymentType = this.activePayment.value;

    this.payment.notes = this.payment.customer.notes;
    this.payment.paymentMethod = {
      methodId: this.selectedPaymentMethod._id,
      qboId: this.selectedPaymentMethod.qboId,
      name: this.selectedPaymentMethod.name,
      type: this.selectedPaymentMethod.type,
    };
    if (this.isFinalizedSectionVisible) {
      this.payment.paymentMethod.selectedThirdPartyVendor = this.payment.thirdPartyVendor;
      delete this.payment.thirdPartyVendor;
    }

    const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
    const time = this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm);
    let paymentDate = `${date} ${time}`;

    if (isPaymentDelete && this.selectedPaymentMethod.type === 'CREDIT_CARD' && (this.afterOnlinePayment || this.afterSwipePayment)) {
      paymentDate = ``;
      delete this.payment.paymentDate;
      delete this.payment.collectedAmount;
    }

    this.payment.currentOrderSession = this.helperService.getOrderSessions(this.payment.estimate.estimateId);

    this.httpService
      .updatePayment({ ...this.payment, paymentDate })
      .then(
        (payment) => {
          this.closePaymentModal(
            {
              isSuccess: true,
              result: {
                isPaidFull: this.disabled ? false : this.payment.isPaidFull,
                workFlowPaid: this.workFlowDisabled ? false : this.payment.workFlowPaid,
                payrixResponse: this.payRixResponse.payrixResponse || null,
                estimate: {
                  _id: this.payment.estimate.estimateId,
                  ...this.payment.estimate,
                  customer: this.payment.customer,
                },
                payment,
              },
              reviewConfiguration: this.reviewConfiguration,
            },
            true,
          );

          this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
          this.helperService.showToaster('success', messages.paymentSaved);
        },
        (error) => {
          if (error && error.isOrderRestricted) {
            this.isOrderLocked = true;
            this.orderRestriction = error.restriction;
          } else {
            this.helperService.showToaster('error', error);
            this.closePaymentModal({ isSuccess: false }, true);
          }
        },
      )
      .finally(() => {
        this.isProcessing = false;
      });
  }

  openReviewDialog(order) {
    const data = {
      isSuccess: true,
      isPaidFull: order.isPaidFull,
      estimateId: order._id,
      paymentId: this.paymentHistory.length > 0 ? this.paymentHistory[0]._id : order?.paymentHistory && order?.paymentHistory?.length > 0 ? order?.paymentHistory[0]?._id : null,
    };
    if (order.isPaidFull) {
      this.dataService.sendData(this.dataService.typeDialog('add-review', null, null, null, data));
    }
  }

  openMarkRoThirdPartyDialog(order: any) {
    const data = {
      thirdPartyInfo: order?.thirdPartyInfo || {},
      orderId: order._id,
      isThirdPartyRo: order?.isThirdPartyRo || false,
      isFinalizedRO: order?.isFinalized || false,
    };
    if (order?.finalizeType === 'thirdPartyAccounts' && (!order?.thirdPartyInfo?.poNumber || !order?.thirdPartyInfo?.claimNumber)) {
      this.dataService.sendData(this.dataService.typePassData('mark-third-party-info-missing', data));
    }
  }

  async createCreditPayment() {
    try {
      // if (!this.validation()) {
      //   return;
      // }
      this.isProcessing = true;
      const appliedCreditMemos = this.availableCredits.filter(({ appliedAmount }) => Number(appliedAmount));
      const payload = {
        amount: this.payment.collectedAmount,
        customer: this.payment.customer,
        date: this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmddhhmm),
        estimate: this.payment.estimate,
        notes: this.payment.notes,
        appliedCreditMemos: appliedCreditMemos,
      };

      await this.httpService.createApplyMemo(payload);

      delete this.payment._id;
      this.paymentId = '';
      this.isPaymentLoading = false;
      this.activePayment = {};

      this.helperService.showToaster('success', `Credit payment added`);
      this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
      this.setEstimateDetails({ _id: this.payment.estimate.estimateId });
      this.getPaymentHistory(this.payment.estimate.estimateId);
      // this.ref.close({});
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isProcessing = false;
    }
  }

  /** Making a new payment */
  createTransaction() {
    if (this.isProcessing) {
      return;
    }
    if (this.activePayment.value === 'creditPayment') {
      this.createCreditPayment();
      return;
    }

    delete this.payment._id;
    this.isProcessing = true;
    this.payment.paymentType = this.activePayment.value;
    this.payment.paymentMethod = {
      methodId: this.selectedPaymentMethod._id,
      qboId: this.selectedPaymentMethod.qboId,
      name: this.selectedPaymentMethod.name,
      type: this.activePayment.value,
    };
    const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
    const time = this.paymentTime ? this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm) : this.dateService.formatDate(this.defaultPaymentTime, datetimeFormat.hhmm);
    const paymentDate = `${date} ${time}`;

    if (this.isNotVehicleInfo) {
      this.payment.isPaidFull = false;
    }
    let payload = { ...this.payment, ...this.payRixResponse, paymentDate };

    if (this.isFinalizedSectionVisible) {
      payload.paymentMethod.selectedThirdPartyVendor = this.payment.thirdPartyVendor;
      delete payload.thirdPartyVendor;
    }

    payload.currentOrderSession = this.helperService.getOrderSessions(this.payment.estimate.estimateId);

    if (this.activePayment.value === 'card' && this.isPaymentOnline && this.isSwipeOnline && this.featureIsPayRixEnable && this.isPayrixConnected) {
      payload.terminalId = this.selectedTerminal.id;
    }

    // if(this.activePayment.value === 'writeOff' && this.isFinalizedSectionVisible) {
    //   this.payment.estimate.totalDue = this.calculationService.roundOff(this.payment.estimate.total.grand) - this.writeOffPayment;
    // }

    if (this.isGlobalPayEnabled && this.isGlobalPayConnected && this.afterOnlinePayment) {
      this.createGloabalPayment(payload);
    } else {
      this.createPaytment(payload);
    }
  }

  paymentProcessedCustomEvent(payment, processor) {
    if (this.dataService.isGainSightPXEnabled) {
      const paymentProcessed: any = {
        paymentCreationSource: this.isOpenFromKanban ? 'Workboard Kanban' : this.isOpenFromTopNav ? 'Top Navigation bar' : this.isOpenFromRO ? 'RO screen' : '',
        transactionDateTime: payment.paymentDate,
        transactionAmount: payment.amount,
        roNumber: payment.estimate?.code || '',
        customerId: payment.customer?.customerId || '',
        custoomerName: payment.customer?.fullName || '',
        paymentProcessor: processor,
        transactionType: payment.isOnline ? 'cardOnline' : payment.isCardSwipe ? 'cardSwipe' : '',
      };

      (<any>window).aptrinsic('track', 'Payment Processed', paymentProcessed);
    }
  }

  // create GP paymets
  createGloabalPayment(payload) {
    this.httpService.createGlobalPayment(payload).then(
      (payment) => {
        this.isProcessing = false;
        this.payment._id = payment._id;
        this.paymentId = this.payment._id;
        // refetch updated data
        this.getPaymentHistory(payment.estimate.estimateId);
        this.getPaymentDetails();
      },
      (err) => {
        this.afterOnlinePayment = false;
        this.showNotes = false;
        this.helperService.showToaster('error', err);
        this.isProcessing = false;
      },
    );
  }
  // create paymet with Manual , payrix and termail
  createPaytment(payload) {
    this.httpService
      .createPayment(payload)
      .then(
        (payment) => {
          this.getCustomerCreditMemos();
          // Payment through Payrix and append ID in payment object.
          if (this.afterOnlinePayment || this.afterSwipePayment || this.isFinalizedSectionVisible) {
            this.isProcessing = false;
            this.payment._id = payment._id;
            this.paymentId = this.payment._id;

            if (payment.isPartialPaymentApproved) {
              this.partialPaymentApproved(payment);
            } else if (this.isFinalizedSectionVisible) {
              delete this.payment._id;
              delete payment.payrixResponse;
              delete payment.globalPaymentResponse;
              this.payRixResponse = {};
              this.globalPaymentResponse = {};
              payment.paymentProvider = '';
              this.paymentId = '';
              this.isPaymentLoading = false;
              this.activePayment = {};
              this.setEstimateDetails({ _id: payment.estimate.estimateId });
            }

            // Refetch updated data
            this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
            this.getPaymentHistory(payment.estimate.estimateId);
            this.getPaymentDetails();
            return;
          }

          if (this.isFinalizedSectionVisible) {
            this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
            this.getPaymentHistory(payment.estimate.estimateId);
            this.getPaymentDetails();
          }

          this.closePaymentModal(
            {
              isSuccess: true,
              result: {
                isPaidFull: this.disabled ? false : this.payment.isPaidFull,
                workFlowPaid: this.workFlowDisabled ? false : this.payment.workFlowPaid,
                estimate: {
                  _id: this.payment.estimate.estimateId,
                  ...this.payment.estimate,
                  customer: this.payment.customer,
                },
                amount: this.payment.collectedAmount,
                payment,
              },
              reviewConfiguration: this.reviewConfiguration,
            },
            true,
          );

          this.helperService.showToaster('success', messages.paymentCreated);
          this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
        },
        (error) => {
          if (error && error.isOrderRestricted) {
            this.isOrderLocked = true;
            this.orderRestriction = error.restriction;
          } else {
            this.helperService.showToaster('error', error);
            this.closePaymentModal({ isSuccess: false }, true);
          }
        },
      )
      .finally(() => {
        this.isProcessing = false;
      });
  }
  // load payRix script
  async openScreen() {
    // payrix
    if (this.featureIsPayRixEnable && this.isPayrixConnected) {
      this.openPayrixModel();
    } else {
      // gloabal payments
      this.openGlobalPaymentModel();
    }
  }

  openGlobalPaymentModel() {
    const ref = this.dialogService.open(GlobalPaymentFieldComponent, {
      width: '55%',
      styleClass: 'global-payment-dialog',
      showHeader: false,
      data: {
        payment: this.payment,
        credentials: this.credentials,
        orderVehicle: this.orderVehicle,
        globalPaymentMehod: this.globalPaymentMehod,
        activePaymentValue: this.activePayment.value,
        paymentTime: this.paymentTime,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.afterOnlinePayment = true;
        this.showNotes = true;
        this.paymentId = data._id;
        this.paymentProcessedCustomEvent(data, data.paymentProvider);
        // this.getPaymentHistory(data.estimate.estimateId);
        // this.getPaymentDetails();
        this.cdr.detectChanges();
        if (data.isPartialPaymentApproved) {
          //  call Partial Payment Approved modal
          this.partialPaymentApproved(data, data.globalPayResponse?.card?.cardholder_name);
        } else {
          this.getPaymentHistory(data.estimate.estimateId);
          this.getPaymentDetails();
        }
      }
      onClose.unsubscribe();
    });
  }

  //  partial payment approved
  partialPaymentApproved(partialPayment, cardHolderName?) {
    this.partialPayment = partialPayment;
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-12',
        isHTML: true,
        title: 'Partial Payment Approved',
        message: `
        <hr class="line-custome">
        <div class="row">
        <p class="pl-3">Partial payment has been approved for this transaction. </p>
        </div>
        <div class="row">
            <div class="col-10">
              <span class="font-600">Requested Amount:</span>
            </div>
            <div class="col-2 align-right">
              <span> $${this.payment?.collectedAmount}</span>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-10">
              <span class="font-600">Charged Amount:</span>
              <br>
              <span class="transaction-details">
              on card, ${this.partialPayment.paymentMethod?.name} ${this.partialPayment.card4Digits}
              ${cardHolderName ? 'by' + cardHolderName : ''}
              at ${this.dateService.formatDate(this.partialPayment.updatedAt, datetimeFormat.mmmdyyhhmmaa)}
              </div>
            <div class="col-2 align-right">
              <span> $${this.partialPayment.amount}</span>
            </div>
        </div>

        <br>
        <p>
        Would you like to void the transaction or proceed with partial payment of $${this.partialPayment.amount}
        </p>

        <hr class="line-custome">`,
        button: {
          success: { title: 'Proceed' },
          cancel: { title: 'Void' },
        },
      },
    });

    const onClose = ref.onClose.subscribe((confirm) => {
      if (confirm.isSuccess) {
        this.getPaymentHistory(this.partialPayment.estimate.estimateId);
        this.getPaymentDetails();

        ref.close();
      } else {
        if (this.partialPayment.paymentProvider == 'payrix') {
          this.helperService.showToaster('error', 'With Card swipe transactions, Void from the app can only be processed after a day. Please try the void from the terminal device');
        } else {
          this.createVoid();
        }
      }
      onClose.unsubscribe();
    });
  }

  /**
   * Create refund against payment
   */
  private createVoid(): void {
    // this.isSubmitting = true;
    const date = this.dateService.formatDate(new Date(), datetimeFormat.yyymmdd);
    const time = this.dateService.formatDate(new Date(), datetimeFormat.hhmm);
    this.partialPayment.refundDateTime = `${date} ${time}`;
    const payloadData = {
      paymentId: this.partialPayment._id,
      payload: {
        type: '4', // always void
        amount: Number(this.partialPayment.amount),
        notes: 'Payment voided due to partial payment',
        refundDate: this.partialPayment.refundDateTime,
      },
    };
    this.httpService
      .createRefund(payloadData)
      .then(() => {
        this.helperService.showToaster('success', 'Void successful');
        this.ref.close();
      })
      .catch((err) => this.helperService.showToaster('error', err))
      .finally(() => {
        this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
      });
  }

  async openPayrixModel() {
    await this.checkSwapPendingService(this.payment.estimate.estimateId, true);
    if (!this.isSwipeRequestPending) {
      const ref = this.dialogService.open(PayrixPaymentFieldComponent, {
        width: '55%',
        styleClass: 'payrix-dialog',
        showHeader: false,
        data: {
          payment: this.payment,
          merchantId: this.merchantId,
          apiKey: this.apiKey,
          orderVehicle: this.orderVehicle,
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (isSuccess) {
          this.payRixResponse.payrixResponse = data;
          //  setting payment method;
          if (data.data && data.data[0] && data.data[0].payment && data.data[0].payment.method) {
            const [method] = this.payrixPaymentMethod.filter(({ integrationId }) => `${integrationId}` === `${data.data[0].payment.method}`);

            if (method) {
              this.payRixResponse.payrixResponse.paymentMethod = method.name;
              this.onCardTypeSelect(method);
            }
          }
          this.paymentProcessedCustomEvent(data, data.paymentProvider || 'payrix');

          this.payment.card4Digits = data.data[0].payment.number;
          this.payment.cardConfNo = data.data[0].authorization;
          this.payment.isOnline = true;
          this.payment.paymentProvider = 'payrix';
          this.payment.collectedAmount = data.data[0].originalApproved / 100;
          if (!this.isRevenueRecognitionSettleEnabled) {
            this.afterOnlinePayment = true;
          }

          this.showNotes = true;
          this.payment.workFlowPaid = this.payment.isPaidFull;
          this.onSubmit(true);
          this.cdr.detectChanges();
        }
        onClose.unsubscribe();
      });
    }
  }

  swipeCard(data: boolean) {
    if (this.afterOnlinePayment) {
      return;
    } else {
      this.isPaymentOnline = data;
      this.isSwipeOnline = data;
    }

    if (this.featureIsPayRixEnable && this.isSwipeOnline && this.activePayment.value === 'card') {
      this.showNotes = false;
    } else {
      this.showNotes = true;
    }
  }

  async openCardSwipe() {
    if (!this.isGlobalPayCardSwipConnected) {
      await this.checkSwapPendingService(this.payment.estimate.estimateId, true);
    }
    if (!this.isSwipeRequestPending) {
      this.transactionDialogue = this.dialogService.open(SwipeCardConfirmationComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          terminal: this.selectedTerminal,
          isProcessing: this.selectedTerminal.isTransactionPending,
          amount: this.payment.collectedAmount,
          id: this.payment.estimate.estimateId,
        },
      });

      this.transactionDialogue.onClose.subscribe((res) => {
        this.isProcessing = false;
        if (res && res.isSuccess !== undefined && res.isSuccess) {
          if (this.dataService.isPrimaryPaymentGlobalPay) {
            this.createGlopabPaySwipeTransaction();
          } else {
            this.createSwipeTransaction();
          }
        }
      });
    }
  }

  createSwipeTransaction() {
    if (this.isProcessing || this.afterSwipePayment) {
      return;
    }
    this.isProcessing = false;
    this.getTerminals();
    delete this.payment._id;
    this.payment.paymentType = this.activePayment.value;
    this.payment.paymentMethod = {
      methodId: this.selectedPaymentMethod._id,
      qboId: this.selectedPaymentMethod.qboId,
      name: this.selectedPaymentMethod.name,
      type: this.activePayment.value,
    };
    const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
    const time = this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm);
    const paymentDate = `${date} ${time}`;
    const payload = { ...this.payment, ...this.payRixResponse, paymentDate };

    if (this.activePayment.value === 'card' && this.isPaymentOnline && this.isSwipeOnline && this.featureIsPayRixEnable && this.isPayrixConnected) {
      payload.terminalId = this.selectedTerminal.id;
    }

    this.httpService.createPaymentTerminal(payload).then(
      (payment) => {
        this.transactionDialogue = this.dialogService.open(SwipeCardConfirmationComponent, {
          width: '30%',
          styleClass: 'small-heading-dialog',
          showHeader: false,
          data: {
            styleClassHeading: 'font-14',
            terminal: this.selectedTerminal,
            amount: this.payment.collectedAmount,
            isProcessing: true,
            id: this.payment.estimate.estimateId,
          },
        });
        this.transactionDialogue.onClose.subscribe(
          (e) => {
            if (e && e.error && e.data.error !== undefined) {
              this.helperService.showToaster(e.data.error ? 'success' : 'error', e.data.error ? 'Transaction successful' : 'Transaction Failed');
              if (e.data.error) this.paymentProcessedCustomEvent(payload, payload.paymentProvider || 'payrix');
            }
            this.isProcessing = false;
          },
          (error) => {
            this.helperService.showToaster('error', error);
            this.transactionDialogue.close({ isSuccess: false });
            this.isProcessing = false;
          },
        );
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  createGlopabPaySwipeTransaction() {
    this.showProgressModal();
    if (this.isProcessing || this.afterSwipePayment || !this.selectedTerminal.id) {
      return;
    }
    this.isProcessing = false;
    delete this.payment._id;

    this.payment.paymentType = this.activePayment.value;
    this.payment.paymentMethod = {
      methodId: this.selectedPaymentMethod._id,
      qboId: this.selectedPaymentMethod.qboId,
      name: this.selectedPaymentMethod.name,
      type: this.activePayment.value,
    };
    const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
    const time = this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm);
    const paymentDate = `${date} ${time}`;
    const payload = { ...this.payment, ...this.globalPaymentResponse, paymentDate };
    payload.paymentProvider = 'globalPay';
    payload.terminalId = this.selectedTerminal.id;

    this.httpService
      .addPaymentCardSwip(payload)
      .then(
        (payment) => {
          this.payment = payment;
          this.paymentId = payment._id;
          this.transactionDialogue.close({ isSuccess: false });
          this.paymentProcessedCustomEvent(payload, payload.paymentProvider || 'globalPay');
          this.getPaymentDetails();
          this.getPaymentHistory(this.payment.estimate.estimateId);
          this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
          this.afterOnlinePayment = true;
          this.afterSwipePayment = true;
          this.showNotes = true;
          this.helperService.showToaster('success', 'Transaction successful');
          this.isProcessing = false;
          this.isSwipeOnline = false;
        },
        (err) => {
          // parse error to see its and time out error
          const timeoutError = err.split(':')[1].trim() === 'gateway time-out' || false;
          this.isProcessing = false;
          // if time out error do nothing do not close the model
          if (timeoutError) {
          } else this.transactionDialogue.close({ isSuccess: false });
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isInvoiceLocked = false;
      });
  }

  onTerminalSelect($event: any) {
    this.selectedTerminal = $event;
  }

  isOrderResctricted(restriction: any = {}) {
    if (!this.isLockOrderEnabled) return true;

    if (restriction) {
      return this.helperService.isLockOrderSessionExist(restriction.token) || !restriction.status || restriction.status === 'readOnly';
    } else {
      return false;
    }
  }

  isCardOnlineDisabled() {
    if (this.featureIsPayRixEnable && this.isPayrixConnected) {
      return false;
    } else if ((this.isGlobalPayCardSwipConnected && (!this.isGlobalPayConnected || !this.isGlobalPayEnabled)) || this.paymentId) {
      return true;
    } else {
      return false;
    }
  }

  public handleCreditChange(value: any, index: number) {
    if (value > this.availableCredits[index].remainingAmount) {
      this.availableCredits[index].error = '* Amount must be less than the remaining balance';
    } else {
      this.availableCredits[index].appliedAmount = value;
      this.availableCredits[index].error = '';
    }

    const creditToApply = this.availableCredits.map((memo) => Number(memo.appliedAmount)).reduce((acc, val) => acc + val);

    this.remainingBalance = this.calculationService.roundOff(this.payment.estimate.total - this.payment.estimate.paid - creditToApply);
    this.remainingBalance = this.calculationService.roundOff(this.remainingBalance);
    this.payment.collectedAmount = creditToApply;

    if (!this.paymentId) {
      this.payment.isPaidFull = !this.remainingBalance;
    }

    if (this.remainingBalance < 0) {
      this.remainingBalanceValidation = true;
    } else {
      this.remainingBalanceValidation = false;
    }
  }

  isPaymentTypeActive(method: any) {
    if (method?.value === 'creditPayment') {
      return method.disabled || this.isArchived || this.afterOnlinePayment || this.afterSwipePayment || this.isFetchingCreditMemos;
    } else {
      return !this.paymentMethodsActive[method?.value] || method.disabled || this.isArchived || this.afterOnlinePayment || this.afterSwipePayment;
    }
  }

  setFinalizationState(order: any) {
    this.payment.collectedAmount = order.total.unpaid;
    this.payment.estimate.isFinalized = order.isFinalized;
    this.payment.estimate.finalizeType = order.finalizeType;
    this.setEstimateDetails({ ...order, orderId: order._id });
  }

  handleSettlementOption(finalizeType: string) {
    if (finalizeType === 'accountsReceivable') {
      this.handleChange('0', 'collectedAmount');
    }
  }

  validateChangePaymentData() {
    if (this.paymentId && !this.changePaymentData && this.isPaymentDataPrivilgesEnabled) {
      return true;
    }
    return false;
  }
}
